export default "__VITE_ASSET__CnSHyDkb__"